import React from 'react';

import {SmallLoader} from '@kit';

import {getApolloError, humanEnumeration} from '../../../../components/utils';
import {Markdown} from '../../../../components/utils/md';
import {useOriginQuery} from '../../../../generated/types';
import {useCharacter} from '../character-context';
import {alignmentLabel} from '../model/alignments';
import {optionLabel} from '../model/choice-options';
import {flattenChoices, flattenFeatures} from '../model/feature-tree';

import css from './sheet.module.css';

export const OriginTab: React.FC = () => {
	const {state} = useCharacter();
	if (!state.originId) return <p className={css.muted}>Происхождение ещё не выбрано.</p>;
	return <OriginDetails originId={state.originId} />;
};

const OriginDetails: React.FC<{originId: string}> = ({originId}) => {
	const {catalog, state, features} = useCharacter();
	const {data, loading, error} = useOriginQuery({variables: {id: originId}});
	const origin = data?.origin;

	const chosen = flattenFeatures(features.origin)
		.filter((instance) => !instance.feature.featId)
		.flatMap((instance) => flattenChoices(instance.choices))
		.flatMap((choice) => choice.selected.map((key) => optionLabel(choice.group, key, catalog)));

	if (loading) return <SmallLoader />;
	if (error) return <p className={css.muted}>{getApolloError(error).message}</p>;
	if (!origin) return null;

	return (
		<div className={css.origin}>
			<h3 className={css.originTitle}>{origin.title}</h3>
			<dl className={css.facts}>
				{state.alignment && (
					<div className={css.fact}>
						<dt>Мировоззрение</dt>
						<dd>{alignmentLabel(state.alignment)}</dd>
					</div>
				)}
				{chosen.length > 0 && (
					<div className={css.fact}>
						<dt>Выбрано</dt>
						<dd>{humanEnumeration(chosen)}</dd>
					</div>
				)}
			</dl>
			<Markdown
				text={`*Характеристики:* ${origin.abilities}
*Черта:* ${origin.feat}
*Умения в навыках:* ${origin.skills}
*Умения в инструментах:* ${origin.instruments}
*Экипировка:* ${origin.equipment}`}
			/>
			<Markdown text={origin.description} />
		</div>
	);
};
